import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=622469ac&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=622469ac&prod&lang=scss"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=622469ac&prod&lang=scss&scoped=true"
import style2 from "./Contacts.vue?vue&type=style&index=2&id=622469ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622469ac",
  null
  
)

export default component.exports